module.exports = __webpack_public_path__ + "assets/img/LTC042.2945915e.png";